import Joi from 'joi';
const homeCategoryTilesBlockSchema = Joi.object({
  type: Joi.string().valid('homeCategoryTiles').required(),
  code: Joi.string().allow('', null),
  eyebrow: Joi.string().allow('', null),
  title: Joi.string().required(),
  description: Joi.string().allow('', null),
  tiles: Joi.array().items(Joi.object({
    id: Joi.string().required(),
    label: Joi.string().required(),
    href: Joi.string().required(),
    image: Joi.string().allow('', null)
  }).unknown(true)).required()
}).unknown(true);
export default homeCategoryTilesBlockSchema;